import {Button } from "@material-ui/core";
import Challenge from "./Challenge"; // Update this line
import "./About.css"

export default function About(props) {
    return(
        <div className="about">
            <div className="header">
                <Button
                    variant="contained"
                    color="primary"
                    style={{
                        background: "transparent",
                        border: "none",
                        boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)",
                        backdropFilter: "blur(10px)",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "0px",
                    }}
                    onClick={props.onHome}
                    >
                    Home
                    </Button>
                    <Button
                    variant="contained"
                    color="primary"
                    style={{
                        background: "transparent",
                        border: "none",
                        boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)",
                        backdropFilter: "blur(10px)",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "0px",
                    }}>
                    About
                </Button>
            </div>
            <Challenge/> 
            <div classname="footer">

            </div>
        </div>
    )
}
